export default "__VITE_ASSET__86eea884__"